import { render, staticRenderFns } from "./InquirySingleOffer.vue?vue&type=template&id=b12358ce&"
import script from "./InquirySingleOffer.vue?vue&type=script&lang=js&"
export * from "./InquirySingleOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports